export default {
    fields: [
        {
            key: "_selected",
            label: "#",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            fixed: true,
            _style: "width:5%",
        },
        {
            key: "LeadId",
            label: "Lead Id",
            sorter: false,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Email",
            label: "Email",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Phone",
            label: "Phone",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "FirstName",
            label: "First Name",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "LastName",
            label: "Last Name",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Origin",
            label: "Origin",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "ProviderName",
            label: "Provider Name",
            sorter: true,
            active: true,
            _active: false,
            filter: false,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Message",
            label: "Message",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "DeliveryStatus",
            label: "Status",
            sorter: true,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "CreatedAt",
            label: "Created At",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _style: "width:15%",
        },
        {
            key: "DeliveryCreatedAtTimestamp",
            label: "Sent At",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _style: "width:15%",
        },

    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: {
        values: [5, 10, 20, 50, 100],
    },
    orderField: "DeliveryId",
    dateFieldFilter: "DeliveryCreatedAtDate",
    matchResponse: "data.items",
    matchResponseCurrentPage: "data.currentPage",
    matchResponsePages: "data.pages",
}